import { useSelector } from 'react-redux';

const useIsSignedIn = () => {
  const signedIn = useSelector((state) => state.user.signedIn);
  const loading = useSelector((state) => state.user.loading);

  // Return null (loading/indeterminate) when:
  // 1. Redux loading flag is true
  // 2. signedIn is still null/undefined (initial state, auth not yet checked)
  // This prevents the homepage from flashing between logged-out and logged-in states
  if (loading || signedIn == null) {
    return null;
  }

  return signedIn;
};

export default useIsSignedIn;
